import { type FC } from 'react';

interface PriorityBadgeProps {
  priority: string;
  size?: 'sm' | 'md';
}

const priorityMap: Record<string, { classes: string; icon: string }> = {
  'Baixa': { classes: 'bg-gray-50 text-gray-600 border-gray-200', icon: 'ri-arrow-down-line' },
  'Normal': { classes: 'bg-blue-50 text-blue-700 border-blue-200', icon: 'ri-subtract-line' },
  'Alta': { classes: 'bg-orange-50 text-orange-700 border-orange-200', icon: 'ri-arrow-up-line' },
  'Urgente': { classes: 'bg-red-50 text-red-700 border-red-200', icon: 'ri-alert-line' },
  'Prazo fatal': { classes: 'bg-red-100 text-red-800 border-red-300 animate-pulse', icon: 'ri-timer-flash-line' },
};

const PriorityBadge: FC<PriorityBadgeProps> = ({ priority, size = 'sm' }) => {
  const config = priorityMap[priority] || priorityMap['Normal'];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-medium whitespace-nowrap ${sizeClasses} ${config.classes}`}>
      <i className={`${config.icon} ${size === 'sm' ? 'text-xs' : 'text-sm'}`}></i>
      {priority}
    </span>
  );
};

export default PriorityBadge;